import { AppPathnames, AppStaticPathnames } from "@/i18n/routing";
import { ERoles } from "./roles";

export const roleHome: Record<ERoles, AppStaticPathnames> = {
  [ERoles.OrganizationUser]: "/map",
  [ERoles.OrganizationAdmin]: "/organization/users",
  [ERoles.SuperAdmin]: "/manage/users",
  [ERoles.Admin]: "/manage/users",
  [ERoles.User]: "/map",
};
